import React from 'react';
import { View } from 'react-native';
import Svg, { Rect } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import { IS_WEB } from '@/utils/platform';

export const BookShelf = ({
  color = 'none',
  size = 24,
  style,
  fillColor,
  ...props
}: IconProps) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg
          width={size}
          height={size}
          viewBox="0 0 44 44"
          fill={fillColor}
          style={style as React.CSSProperties}
        >
          <rect
            x="9"
            y="10"
            width="5.37832"
            height="23.7407"
            rx="1"
            stroke={color}
            strokeWidth="2"
          />
          <rect
            x="17.6055"
            y="10"
            width="5.37832"
            height="23.7407"
            rx="1"
            stroke={color}
            strokeWidth="2"
          />
          <rect
            width="5.38"
            height="22.6738"
            rx="1"
            transform="matrix(0.971002 -0.239073 0.258308 0.966062 25.5498 12.0957)"
            stroke={color}
            strokeWidth="2"
          />
        </svg>
      </View>
    );
  }

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 44 44"
      fill={fillColor}
      style={style}
      {...props}
    >
      <Rect
        x="9"
        y="10"
        width="5.37832"
        height="23.7407"
        rx="1"
        stroke={color}
        strokeWidth="2"
      />
      <Rect
        x="17.6055"
        y="10"
        width="5.37832"
        height="23.7407"
        rx="1"
        stroke={color}
        strokeWidth="2"
      />
      <Rect
        width="5.38"
        height="22.6738"
        rx="1"
        transform="matrix(0.971002 -0.239073 0.258308 0.966062 25.5498 12.0957)"
        stroke={color}
        strokeWidth="2"
      />
    </Svg>
  );
};
